import React, { useState } from 'react';

import moment from 'moment/moment';
import Alert from '../../../../components/Alert';
import { cloneObject } from '../../../../utils';
import { PageContainer } from '../../../../styles/styles';
import DatepickerRange from '../../../../components/Inputs/DatepickerRange';
import Button from '../../../../components/Button';

import { buscaDadosConsultasFuturas, buscaDadosConsultasRealizadas } from '../../../../services';

import * as S from './styles';
import ScheduleItem from './ScheduleItem';
import schema from './schema';
import PageLoader from '../../../../components/PageLoader';

function DadosHistoricoConsultas({ location: { dataBeneficiario } }) {
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(true);
    const [searhType, setSearhType] = useState('A');
    const [dataTable, setDataTable] = useState([]);
    const [filterValues, setFilterValues] = useState(cloneObject(schema));
    const [rangeLimits, setRangeLimits] = useState({
        min: schema.rangeDate.value[0],
        max: schema.rangeDate.value[1],
    });
    const [emptyMessage] = useState('Não encontramos consultas para este beneficiário eventual.');

    async function getDadosPassados() {
        setLoading(true);
        setDataTable([]);

        const payloadConsultasRealizadas = {
            cabecalho: {
                canal: 'M',
                codigoEmpresaOrigem: '1',
                divisaoNegocio: '1',
                empresaOrigemAtendimento: '1',
                origemContrato: '1',
                tipoContrato: '1',
                token: '1',
                unidadeNegocio: '1',
            },
            carteirinha: dataBeneficiario.carteirinha,
            compareceuConsulta: '',
            consultaId: 0,
            consultaSequencia: 0,
            dataConsulta: '',
            dataFim: searhType === 'H' ? moment(rangeLimits.max).format('DD/MM/YYYY') : ' ',
            dataInicio: searhType === 'H' ? moment(rangeLimits.min).format('DD/MM/YYYY') : ' ',
            quantidadeOcorrencias: 0,
            tipoConvenio: '',
        };

        let responseDados;

        if (searhType === 'H') {
            responseDados = await buscaDadosConsultasRealizadas(payloadConsultasRealizadas);
        } else {
            responseDados = await buscaDadosConsultasFuturas(payloadConsultasRealizadas);
        }

        let dataArray = [];

        if (typeof responseDados.dadosConsulta !== 'undefined' && responseDados.dadosConsulta.length) {
            dataArray = responseDados.dadosConsulta.map((element) => ({
                data: element.data,
                dataAtendimentoFormatt: moment(element.data).format('YYYY/MM/DD'),
                horario: element.horario,
                medico: element.medico.nome,
                prestador: element.prestador.nome,
                especialidade: element.especialidade.descricao,
                idConsulta: element.idConsulta,
                sequenciaConsulta: element.sequenciaConsulta,
                endereco_logradouro: element.prestador.endereco[0].logradouro,
                endereco_numero: element.prestador.endereco[0].numero,
                endereco_cep: element.prestador.endereco[0].cep,
                endereco_bairro: element.prestador.endereco[0].bairro,
                endereco_complemento: element.prestador.endereco[0].complemento,
                endereco_cidade: element.prestador.endereco[0].cidade,
                endereco_estado: element.prestador.endereco[0].estado,
                endereco_codigo: element.prestador.endereco[0].codigo,
                prestador_codigo: element.prestador.codigo,
            }));

            setDataTable(dataArray);
        }

        setLoading(false);
    }

    React.useEffect(() => {
        getDadosPassados();
    }, [searhType]);

    React.useEffect(() => {
        getDadosPassados();
    }, []);

    function handleChangeFilter(event) {
        const { id, value, draftFlow } = event;

        const field = cloneObject({ ...filterValues[id], value, error: '', draftFlow });

        setFilterValues({
            ...filterValues,
            [id]: field,
        });
    }

    function handleChangeRange(date, _, { range }) {
        if (!date) {
            setRangeLimits({
                min: '',
                max: '',
            });

            return;
        }

        const cloneDate = cloneObject(date);

        if (range === 'start') {
            setRangeLimits({
                ...rangeLimits,
                min: moment(cloneDate[0]),
            });
        }

        if (range === 'end') {
            setRangeLimits({
                ...rangeLimits,
                max: moment(cloneDate[1]),
            });
        }
    }

    return (
        <>
            <PageContainer>
                <S.OptionSelection>
                    <S.OptionButton active onClick={() => setSearhType('F')}>
                        Agendadas
                    </S.OptionButton>
                    <S.OptionButton onClick={() => setSearhType('H')}>Histórico</S.OptionButton>
                </S.OptionSelection>

                {searhType === 'H' ? (
                    <>
                        <S.FormContainer>
                            <DatepickerRange
                                field={filterValues.rangeDate}
                                onCalendarChange={handleChangeRange}
                                onChange={(event) => handleChangeFilter(event)}
                            />
                            <S.RowButton>
                                <Button onClick={getDadosPassados}>Filtrar</Button>
                            </S.RowButton>
                        </S.FormContainer>
                    </>
                ) : null}
            </PageContainer>

            <S.Content>
                {dataTable.length > 0 ? (
                    dataTable.map((item, key) => (
                        <ScheduleItem
                            key={key}
                            carteirinha={dataBeneficiario.carteirinha}
                            item={item}
                            beneficiario={dataBeneficiario}
                        />
                    ))
                ) : (
                    <Alert type="2" title={emptyMessage} />
                )}
            </S.Content>

            <PageLoader loading={loading} />
        </>
    );
}

export default DadosHistoricoConsultas;
